<template>
  <div class="paper-student">
    <div class="header theme-text">
      <span class="trigger" @click="handleBack"><i class="el-icon-back"></i>返回上级</span>
    </div>
    <div class="steps">
      <el-steps :active="step"
                simple>
        <el-step title="设置筛选规则"
                 @click.native="selectStep(1)">
          <template #icon>
            <div class="circle">1</div>
          </template>
        </el-step>
        <el-step title="选取符合学生">
          <template #icon>
            <div class="circle">2</div>
          </template>
        </el-step>
      </el-steps>
    </div>
    <div class="step-main">
      <div class="main-cont">
        <transition :name="'animation-pull-' + pullStyle">
          <keep-alive :exclude="excludeSteps">
            <component :is="getStep"
                       :condition="condition"
                       :paper-batch-id="extraId"
                       @to-step="selectStep"></component>
          </keep-alive>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import PaperStudentCondition from './condition'
import PaperStudentPreview from './preview'
export default {
  name: 'PaperStudent',
  props: {
    extraId: {
      type: String,
      required: true
    }
  },
  components: {
    PaperStudentCondition,
    PaperStudentPreview
  },
  data () {
    return {
      pullStyle: '',
      step: 1,
      condition: null
    }
  },
  computed: {
    getStep () {
      switch (this.step) {
        case 1:
          return 'PaperStudentCondition'
        case 2:
          return 'PaperStudentPreview'
      }
    },
    excludeSteps () {
      return ['PaperStudentPreview']
    }
  },
  methods: {
    handleBack () {
      this.$emit('hidePopover')
    },
    selectStep (step, condition) {
      this.condition = condition || {}
      this.$nextTick(() => {
        this.step = step
      })
    }
  },
  watch: {
    step: function (newVal, oldVal) {
      if (newVal && oldVal) {
        this.pullStyle = newVal < oldVal ? 'left' : 'right'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.paper-student{
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  & > .header {
    flex: none;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    & > .trigger{
      cursor: pointer;
      .el-icon-back{
        margin-right: 8px;
        font-size: 16px;
      }
    }
  }
  & > .steps {
    flex: none;
    border-top: 1px solid #f3f4f5;
    ::v-deep  .el-steps {
      justify-content: center;
      background-color: #f3f4f5;
      border-radius: 0;
      & > .el-step {
        flex-basis: 50%!important;
        &:last-child {
          flex-basis: auto!important;
        }
        & > .el-step__head {
          cursor: pointer;
          &:not(.is-finish) {
            & > .el-step__icon {
              border-color: #606266;
            }
          }
          & > .el-step__icon {
            border-width: 10px;
            box-sizing: border-box;
            .circle {
              color: #fff;
            }
          }
        }
        & > .el-step__main {
          align-items: center;
          & > .el-step__title {
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            &:not(.is-finish) {
              color: #606266;
            }
          }
          & > .el-step__arrow {
            margin-left: 15px;
            margin-right: 15px;
            height: 1px;
            background-color: #dde5eb;
            &:before,
            &:after {
              display: none;
            }
          }
        }
      }
    }
  }
  & > .step-main {
    flex: auto;
    position: relative;
    border-top: 1px solid #f3f4f5;
    & > .main-cont {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
